module.exports = __webpack_public_path__ + "static/dragula2-9631242843faf7384276ec2525ab07ab.gif";